const classStatus = [
    { label: 'Outstanding class reported', value: 'Outstanding class reported' },
    { label: 'No Outstanding class reported', value: 'No Outstanding class reported' }
];

export default classStatus;
